// A newer version of the app is downloaded and waits. The person decides when to load it: the page is
// rebuilt on load, so unsaved input would be lost, and the banner says so.

import { Button } from "react-aria-components";
import { Glyph } from "../../components/Glyph";
import { cx } from "../../lib/cx";
import { useT } from "../../lib/i18n";
import { useUpdatePrompt } from "../../lib/pwa/useUpdatePrompt";
import styles from "./shell.module.css";

export function UpdateNotice() {
  const t = useT();
  const { needRefresh, applyUpdate } = useUpdatePrompt();
  if (!needRefresh) return null;
  return (
    <div className={cx("sf-block", styles.notice)}>
      <div className="sf-banner sf-banner--info" role="status">
        <Glyph name="info" />
        <div>
          <p className="sf-banner__title">{t("update.title")}</p>
          <p>{t("update.text")}</p>
        </div>
        <div className="sf-banner__act">
          <Button className="sf-plate sf-plate--secondary" onPress={applyUpdate}>
            {t("update.action")}
          </Button>
        </div>
      </div>
    </div>
  );
}
